import { render } from "./OnlineConsultation.vue?vue&type=template&id=3329d582&scoped=true"
import script from "./OnlineConsultation.vue?vue&type=script&lang=js"
export * from "./OnlineConsultation.vue?vue&type=script&lang=js"

import "./OnlineConsultation.vue?vue&type=style&index=0&id=3329d582&scoped=true&lang=scss"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3329d582"]])

export default __exports__